import type { HelpFile } from '../../types/help'
import { AccessRequestWizardTestIds } from '../../../testids/AccessRequestWizardTestIds'

export const accessRequestWizardHelp: HelpFile = {
  docPage: '/docs/governance/access-requests',
  texts: {
    [AccessRequestWizardTestIds.accessRequestWizardPage]:
      'Step-by-step wizard for requesting access. Pick the recipient, choose one or more access profiles, then review and submit. The request enters approval workflow once submitted.',
    // Internal wrapper for SR focus management — no contextual help needed.
    [AccessRequestWizardTestIds.accessRequestStepContainer]: null,
    [AccessRequestWizardTestIds.cardTitleWhoNeedsAccess]:
      'First step — choose whether you are requesting access for yourself or for someone else.',
    [AccessRequestWizardTestIds.cardTitleSelectAccessProfiles]:
      'Second step — pick one or more access profiles to request. Each profile bundles related entitlements and target-system access.',
    [AccessRequestWizardTestIds.cardTitleReviewAndSubmit]:
      'Final step — review the recipient and selected access profiles before submitting the request for approval.',
    [AccessRequestWizardTestIds.btnSelectMyself]:
      'Request access for your own identity.',
    [AccessRequestWizardTestIds.btnSelectSomeoneElse]:
      'Request access on behalf of another identity — typical for managers acting for their team.',
    [AccessRequestWizardTestIds.accessProfileAssociationEditor]:
      'Search and select the access profiles to include in this request.',
    [AccessRequestWizardTestIds.reviewProfileItem]:
      'Access profile included in this request — shown in the review summary before submission.',
    [AccessRequestWizardTestIds.beneficiaryMultiPicker]:
      'Search for identities — pick up to 50 recipients. Selected identities appear above as chips.',
    [AccessRequestWizardTestIds.beneficiaryCounter]:
      'Live count of selected beneficiaries. The counter turns amber at 49 and red at the 50-cap. The picker is disabled at 50 — remove a chip to add another identity.',
    [AccessRequestWizardTestIds.beneficiaryCapMessage]:
      'You have reached the 50-beneficiary cap. Remove a chip to enable the picker again.',
    [AccessRequestWizardTestIds.reviewBeneficiaryChips]:
      'All recipients of this submission, listed by display name.',
    [AccessRequestWizardTestIds.reviewExpansionSummary]:
      'Total expansion: how many access requests will be created — beneficiaries × access profiles.',
    [AccessRequestWizardTestIds.btnPreviousStep]: null,
    [AccessRequestWizardTestIds.btnNextStep]: null,
    [AccessRequestWizardTestIds.btnSubmitRequest]:
      'Submit the request for approval — track progress under My Requests.',
    [AccessRequestWizardTestIds.btnCancel]: null,
  },
}
